import { Component } from '@angular/core';
import { MonitoredServicesComponent } from '../../../../components/monitoring/dashboard/monitored-services.component';

@Component({
    selector: 'app-monitoring-dashboard',
    templateUrl: './monitoring-dashboard.component.html',
    styleUrls: ['./monitoring-dashboard.component.scss'],
    imports: [MonitoredServicesComponent]
})
export class MonitoringDashboardComponent {
}
